<ion-button fill="clear" size="small" (click)="setReminder($event)"
    [ariaLabel]="'core.reminders.setareminderfor' | translate : { title: title, label: labelClean }">
    <ion-icon name="fas-bell" slot="icon-only" *ngIf="timebefore !== undefined" aria-hidden="true" />
    <ion-icon name="far-bell-slash" slot="icon-only" *ngIf="timebefore === undefined" aria-hidden="true" />
</ion-button>

<span class="sr-only" role="status" *ngIf="reminderMessage">{{ reminderMessage }}</span>
